const { convertArrayToCSV } = require('convert-array-to-csv');
import codeListMapper from './CodeListMapper'
const _ = require('underscore');
import exportProjectNameMapper from './ExportProjectNameMapper'

const exportCodesCSVMapper = (projectData, codesData) => {
  const {codes} = codeListMapper(projectData, codesData)
  const {exportFileName} = exportProjectNameMapper(projectData, 'Codes')
  const header = ['Order of Code in List', 'Nested Level', 'Code Name', 'Number of Snippets', 'Code Description', 'Code URL']

  const codesWithoutIds = codes.map((code)=>_.rest(code))

  return {
    projectName: exportFileName,
    codeText: convertArrayToCSV(codesWithoutIds, {
      separator: ',',
      header: header
    })
  }
}

export default exportCodesCSVMapper
